import React from 'react'
import { clone, omit, pick, last } from 'lodash'
import { sortable } from 'react-sortable'
import { Image } from 'react-bootstrap' 
import Flip from 'react-flip-move'
import createClass from "create-react-class"


// TODO SortableList keeps items list as state. this makes the baby muad'dib cry.

const ListItem = createClass({
  displayName: 'SortableListItem',
  render() {
    return (
      <div {...this.props} style={{position : "relative"}}>{this.props.children}</div>
    )
  }
})

const SortableListItem = sortable(ListItem);

type Props = {
  items: [],
  onUpdate: ([]) => void,
  setDraggingIndex: (Number) => void,
  onDrop:  () => void,
  renderItem: (Object) => Object,
  animate: boolean,
}

class SortableList extends React.PureComponent {
  constructor(props) {
    super(props)
    this.state = {
      draggingIndex: null,
      neverDragged: true, // may use this to signal draggability to the user the 1st time
      startedDragging : false,
    }
  }

  props : Props

  updateState(obj) {
    if (obj.draggingIndex) {
      if (!this.state.startedDragging) this.props.setDraggingIndex(obj.draggingIndex)
      this.setState({
        draggingIndex: obj.draggingIndex, 
        neverDragged: this.state.neverDragged && !(obj.items), 
        startedDragging: true
      })
    }
    
    if (obj.items) this.props.onUpdate(obj.items)
    else if (!obj.draggingIndex) {
      this.props.onDrop()
      this.setState({ draggingIndex: null, startedDragging: false })
      this.props.setDraggingIndex(null)
    }
  }

  render() {
    const listItems = this.props.items.map((item, i) => (
      <SortableListItem
        key={item.key}
        updateState={obj => this.updateState(obj)}
        items={this.props.items}
        draggingIndex={this.state.draggingIndex}
        draggingClassName="dragging"
        sortId={i}
        outline="list"
        className={`SortableListItem ${  i == this.state.draggingIndex ? "dragged" : ""}`}
      >
        {this.props.renderItem(item)}
      </SortableListItem>
    ))
    
    if (this.props.animate) {
      return (
        <Flip
          staggerDurationBy="10"
          duration={200}
          enterAnimation="accordionVertical"
          leaveAnimation="accordionVertical"
          typeName="div"
          disableAllAnimations={!!this.state.draggingIndex}
        >
          {listItems}
        </Flip>
      )
    }
    else return (<div>{listItems}</div>)
  }
}

SortableList.defaultProps = {
  renderItem: (x => x), 
  animate: false, 
}

export default SortableList
